<template>
  <div class="text-center">
    <v-dialog v-model="showModal" width="306" persistent>
      <v-card class="popupDialog">
        <v-card-title>
          系統訊息
        </v-card-title>

        <v-card-text>
          {{ messageContent }}
        </v-card-text>

        <v-card-actions>
          <v-btn
            filled
            text
            class="btnToCard"
            @click="$emit('give-showmodal', false)"
          >
            確定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'CustomAlertOverlay',
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    messageContent: {
      type: String,
      default: '',
    },
  },
  computed: {},
  methods: {},
  mounted: function() {},
}
</script>

<style scoped>
.popupDialog {
  min-height: 175px;
  border-radius: 8px;
  position: relative;
}

.v-card__title {
  padding: 20px 0 !important;
  justify-content: center;
  font-size: 18px !important;
  font-weight: bold !important;
  color: #1da7fc;
  line-height: 1.3;
  background-color: white !important;
}

.v-card__text {
  max-height: calc(80vh - 166px);
  padding: 0 10px 20px !important;
  font-size: 16px;
  color: #4a4a4a !important;
  line-height: 1.63;
  text-align: center;
  overflow: auto;
}

.v-card__actions {
  width: 100%;
  height: 56px;
  padding: 0 13.1% !important;
  left: 0;
  color: unset !important;
  bottom: 0;
}

.btnToCard {
  width: 48%;
  height: 44px !important;
  margin: 0 auto;
  background-color: #1da7fc;
  color: #fff !important;
  font-size: 17px !important;
  font-weight: bold !important;
}
</style>
